import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { IrisEmailsMessagesEffects } from './messages/emails-messages.effects';
import { IrisModuleFilterModule } from '../../module-filter/module-filter.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EffectsModule.forFeature([
      IrisEmailsMessagesEffects,
    ]),
    IrisModuleFilterModule,
  ],
})
export class IrisEmailsSandboxModule {
  static readonly type = 'emailsCommonModule';
}
